import React, {Component} from 'react'
import PropTypes from 'prop-types';
import {Navbar, Dropdown} from 'react-bootstrap';
import NavigationMenu from './NavigationMenu';
import isEmpty from 'lodash/isEmpty'
import isString from 'lodash/isString'
import pickBy from 'lodash/pickBy'
import {Link} from 'react-router-dom'

class TopNav extends Component {
    static propTypes = {
        ...NavigationMenu.propTypes,
        brand: PropTypes.any,
        menuConfig: PropTypes.object.isRequired,
        isDropdownMenu: PropTypes.bool,
    };

    render() {
        const {brand, menuConfig, ...rest} = this.props;
        let brandControl;
        if (brand) {
            if (isString(brand)) {
                brandControl = <Navbar.Brand><Link to="/">{brand}</Link></Navbar.Brand>;
            } else {
                brandControl = <Navbar.Brand>{brand}</Navbar.Brand>;
            }
            brandControl = <Navbar.Header>{brandControl}<Navbar.Toggle/></Navbar.Header>;
        }

        const leftMenu = pickBy(menuConfig.subMenus, menuItem => (menuItem.rank >= 0));
        const rightMenu = pickBy(menuConfig.subMenus, menuItem => (menuItem.rank < 0));
        const leftMenuControl = isEmpty(leftMenu) ? false : <NavigationMenu menuConfig={{subMenus: leftMenu}} key="leftMenu" {...rest}/>;
        const rightMenuControl = isEmpty(rightMenu) ? false : <NavigationMenu menuConfig={{subMenus: rightMenu}} key="rightMenu" pullRight {...rest}/>;

        if (this.props.isDropdownMenu) {
            return (
                <Dropdown className="top-nav" id="top-nav">
                    <Dropdown.Toggle noCaret bsStyle="link">
                        <i className="fa fa-bars"/>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {leftMenuControl}
                        {rightMenuControl}
                    </Dropdown.Menu>
                </Dropdown>
            );
        }

        return (
            <Navbar className="top-nav" inverse>
                {brandControl}
                <Navbar.Collapse>
                    {leftMenuControl}
                    {rightMenuControl}
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

export default TopNav;



// WEBPACK FOOTER //
// ./src/components/TopNav.js